var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBsdEducation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 31,
    viewBox: "0 0 168 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_164_33782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6618 20.6944C93.3328 20.6944 93.9509 20.5384 94.516 20.2264C95.0811 19.9144 95.5402 19.5465 95.8934 19.1227C96.0111 19.0168 96.07 18.8932 96.07 18.7519C96.07 18.6342 96.0258 18.5282 95.9375 18.434C95.8492 18.3398 95.7403 18.2928 95.6108 18.2928C95.4931 18.2928 95.3695 18.3457 95.24 18.4517C95.0752 18.6636 94.8662 18.8667 94.6131 19.0609C94.36 19.2552 94.0686 19.4112 93.739 19.5289C93.4093 19.6466 93.0444 19.7055 92.6441 19.7055C91.8906 19.7055 91.249 19.5407 90.7193 19.211C90.1895 18.8814 89.7833 18.434 89.5008 17.8689C89.2182 17.3038 89.077 16.674 89.077 15.9794V15.9971H95.7521C95.8581 15.9971 95.9541 15.9689 96.0402 15.9126L96.1229 15.847C96.2289 15.7469 96.2819 15.6262 96.2819 15.485C96.2701 14.8021 96.1465 14.2017 95.911 13.6837C95.6756 13.1657 95.3695 12.7272 94.9928 12.3681C94.616 12.0091 94.1834 11.7383 93.6948 11.5558C93.2062 11.3733 92.703 11.2821 92.185 11.2821C91.4786 11.2821 90.8105 11.4734 90.1807 11.856C89.5508 12.2386 89.0387 12.7831 88.6443 13.4895C88.2499 14.1958 88.0527 15.0494 88.0527 16.05C88.0527 16.9801 88.247 17.7924 88.6355 18.487C89.024 19.1816 89.5655 19.7231 90.2601 20.1116C90.9547 20.5001 91.7553 20.6944 92.6618 20.6944ZM95.187 15.0435H89.1564L89.2025 14.8218C89.2235 14.7348 89.247 14.6502 89.2732 14.5679L89.3595 14.3283C89.5479 13.8633 89.7922 13.4807 90.0924 13.1804C90.3926 12.8802 90.7281 12.6595 91.0989 12.5182C91.4698 12.377 91.8318 12.3063 92.185 12.3063C92.6559 12.3063 93.1062 12.4064 93.5359 12.6065C93.9656 12.8067 94.3335 13.101 94.6396 13.4895C94.9457 13.878 95.1281 14.3489 95.187 14.9022V15.0435ZM102.021 20.6944C102.527 20.6944 102.995 20.6002 103.425 20.4118C103.855 20.2235 104.231 19.9763 104.555 19.6702C104.879 19.3641 105.129 19.0315 105.306 18.6724L105.27 18.738V19.988C105.27 20.094 105.297 20.19 105.35 20.2761L105.412 20.3589C105.506 20.4648 105.635 20.5178 105.8 20.5178C105.941 20.5178 106.065 20.4648 106.171 20.3589C106.277 20.2529 106.33 20.1293 106.33 19.988V7.97985C106.33 7.8268 106.28 7.70024 106.18 7.60018C106.08 7.50011 105.953 7.45007 105.8 7.45007C105.635 7.45007 105.506 7.50305 105.412 7.609C105.317 7.71496 105.27 7.83857 105.27 7.97985V13.1767L105.225 13.0904C105.091 12.8643 104.932 12.6542 104.748 12.46L104.555 12.271C104.22 11.9649 103.834 11.7236 103.398 11.547C102.963 11.3704 102.498 11.2821 102.003 11.2821C101.226 11.2821 100.526 11.4852 99.902 11.8913C99.278 12.2975 98.7836 12.8567 98.4186 13.5689C98.0537 14.2812 97.8712 15.0847 97.8712 15.9794C97.8712 16.8859 98.0537 17.6923 98.4186 18.3987C98.7836 19.1051 99.281 19.6643 99.9108 20.0763C100.541 20.4884 101.244 20.6944 102.021 20.6944ZM102.127 19.7055C101.515 19.7055 100.964 19.5436 100.476 19.2199C99.9873 18.8961 99.6047 18.4517 99.3281 17.8866C99.0514 17.3215 98.9131 16.6858 98.9131 15.9794C98.9131 15.2731 99.0514 14.6403 99.3281 14.0811C99.6047 13.5219 99.9873 13.0804 100.476 12.7566C100.964 12.4329 101.515 12.271 102.127 12.271C102.751 12.271 103.304 12.4329 103.787 12.7566C104.27 13.0804 104.649 13.5219 104.926 14.0811C105.203 14.6403 105.341 15.2731 105.341 15.9794C105.341 16.6976 105.203 17.3362 104.926 17.8954C104.649 18.4546 104.27 18.8961 103.787 19.2199C103.304 19.5436 102.751 19.7055 102.127 19.7055ZM112.722 20.6414C113.841 20.6414 114.73 20.3353 115.389 19.7231C116.048 19.111 116.378 18.2221 116.378 17.0566V12.0768C116.378 11.9355 116.328 11.8119 116.228 11.7059C116.128 11.6 116.001 11.547 115.848 11.547C115.683 11.547 115.554 11.6 115.46 11.7059C115.365 11.8119 115.318 11.9355 115.318 12.0768V17.0566C115.318 17.9043 115.089 18.5488 114.63 18.9903C114.171 19.4318 113.535 19.6525 112.722 19.6525C111.922 19.6525 111.295 19.4318 110.842 18.9903C110.389 18.5488 110.162 17.9043 110.162 17.0566V12.0768C110.162 11.9355 110.112 11.8119 110.012 11.7059C109.912 11.6 109.785 11.547 109.632 11.547C109.479 11.547 109.353 11.6 109.252 11.7059C109.152 11.8119 109.102 11.9355 109.102 12.0768V17.0566C109.102 18.2221 109.429 19.111 110.082 19.7231C110.736 20.3353 111.616 20.6414 112.722 20.6414ZM122.965 20.6944C123.6 20.6944 124.16 20.609 124.642 20.4383C125.125 20.2676 125.505 20.0675 125.781 19.8379C126.058 19.6084 126.196 19.3994 126.196 19.211C126.196 19.0698 126.155 18.955 126.073 18.8667C125.99 18.7784 125.879 18.7342 125.737 18.7342C125.572 18.7342 125.44 18.796 125.34 18.9197C125.24 19.0433 125.072 19.1698 124.837 19.2993C124.66 19.4053 124.439 19.4995 124.174 19.5819C123.91 19.6643 123.542 19.7055 123.071 19.7055C122.388 19.7055 121.785 19.5436 121.261 19.2199C120.737 18.8961 120.331 18.4517 120.042 17.8866C119.754 17.3215 119.61 16.6858 119.61 15.9794C119.61 15.2848 119.763 14.6579 120.069 14.0987C120.375 13.5395 120.793 13.0951 121.322 12.7655C121.852 12.4358 122.447 12.271 123.106 12.271C123.459 12.271 123.78 12.3004 124.068 12.3593C124.357 12.4182 124.578 12.4829 124.731 12.5535C124.895 12.636 125.019 12.7243 125.102 12.8184C125.184 12.9126 125.269 12.995 125.358 13.0657C125.446 13.1363 125.567 13.1716 125.72 13.1716C125.849 13.1716 125.958 13.1157 126.046 13.0039C126.135 12.892 126.179 12.7772 126.179 12.6595C126.179 12.4123 126.034 12.1827 125.746 11.9708C125.458 11.7589 125.078 11.5911 124.607 11.4675C124.136 11.3439 123.618 11.2821 123.053 11.2821C122.147 11.2821 121.358 11.4969 120.687 11.9267C120.016 12.3564 119.492 12.9244 119.115 13.6308C118.738 14.3371 118.55 15.12 118.55 15.9794C118.55 16.8741 118.735 17.6776 119.106 18.3899C119.477 19.1021 119.995 19.6643 120.66 20.0763C121.325 20.4884 122.094 20.6944 122.965 20.6944ZM131.777 20.6944C132.283 20.6944 132.751 20.6032 133.181 20.4207C133.61 20.2382 133.984 19.9998 134.302 19.7055C134.62 19.4112 134.87 19.0933 135.052 18.7519L135.026 18.7973V19.988C135.026 20.094 135.052 20.19 135.105 20.2761L135.167 20.3589C135.261 20.4648 135.391 20.5178 135.556 20.5178C135.697 20.5178 135.821 20.4648 135.927 20.3589C136.032 20.2529 136.085 20.1293 136.085 19.988V12.0414C136.085 11.8884 136.035 11.7589 135.935 11.6529C135.835 11.547 135.709 11.494 135.556 11.494C135.391 11.494 135.261 11.547 135.167 11.6529C135.073 11.7589 135.026 11.8884 135.026 12.0414V13.1552L134.993 13.0904C134.863 12.8643 134.707 12.6542 134.527 12.46L134.337 12.271C134.008 11.9649 133.622 11.7236 133.181 11.547C132.739 11.3704 132.265 11.2821 131.759 11.2821C130.982 11.2821 130.282 11.4822 129.658 11.8825C129.034 12.2828 128.539 12.8332 128.174 13.5336C127.809 14.2341 127.627 15.0435 127.627 15.9618C127.627 16.8565 127.806 17.6629 128.165 18.3811C128.524 19.0992 129.019 19.6643 129.649 20.0763C130.279 20.4884 130.988 20.6944 131.777 20.6944ZM131.883 19.7055C131.259 19.7055 130.702 19.5436 130.214 19.2199C129.725 18.8961 129.346 18.4487 129.075 17.8778C128.804 17.3068 128.669 16.6681 128.669 15.9618C128.669 15.2436 128.807 14.6079 129.084 14.0546C129.36 13.5013 129.743 13.0657 130.231 12.7478C130.72 12.4299 131.27 12.271 131.883 12.271C132.507 12.271 133.06 12.4358 133.543 12.7655C134.025 13.0951 134.405 13.5366 134.682 14.0899C134.958 14.6432 135.097 15.2672 135.097 15.9618C135.097 16.6681 134.958 17.3068 134.682 17.8778C134.405 18.4487 134.025 18.8961 133.543 19.2199C133.06 19.5436 132.507 19.7055 131.883 19.7055ZM141.471 20.5178C141.73 20.5178 141.954 20.4619 142.143 20.35C142.331 20.2382 142.425 20.0999 142.425 19.9351C142.425 19.8055 142.387 19.6996 142.31 19.6172C142.234 19.5348 142.143 19.4936 142.037 19.4936C141.942 19.4936 141.857 19.5083 141.781 19.5377C141.704 19.5672 141.619 19.5819 141.524 19.5819C141.383 19.5819 141.242 19.5554 141.101 19.5024C140.959 19.4494 140.845 19.3405 140.756 19.1757C140.668 19.0109 140.624 18.7637 140.624 18.434V12.5182H142.39C142.496 12.5182 142.588 12.4917 142.668 12.4388L142.743 12.377C142.837 12.2828 142.884 12.1709 142.884 12.0414C142.884 11.9002 142.837 11.7795 142.743 11.6794C142.649 11.5794 142.531 11.5293 142.39 11.5293H140.624V9.56916C140.624 9.46321 140.596 9.36719 140.539 9.2811L140.474 9.19832C140.374 9.09237 140.247 9.03939 140.094 9.03939C139.941 9.03939 139.814 9.09237 139.714 9.19832C139.614 9.30428 139.564 9.42789 139.564 9.56916V11.5293H138.275C138.169 11.5293 138.075 11.5558 137.992 11.6088L137.913 11.6706C137.813 11.7648 137.763 11.8825 137.763 12.0238C137.763 12.1533 137.813 12.2681 137.913 12.3681C138.013 12.4682 138.134 12.5182 138.275 12.5182H139.564V18.487C139.564 18.9285 139.615 19.2841 139.718 19.5539L139.785 19.7055C139.932 19.988 140.118 20.1852 140.341 20.2971C140.565 20.4089 140.783 20.4737 140.995 20.4913C141.207 20.509 141.366 20.5178 141.471 20.5178ZM145.339 10.1519C145.574 10.1519 145.754 10.096 145.877 9.98415C146.001 9.87231 146.063 9.71044 146.063 9.49853V9.32194C146.063 9.11003 146.001 8.94815 145.877 8.83631C145.754 8.72447 145.58 8.66855 145.356 8.66855C145.121 8.66855 144.936 8.72447 144.8 8.83631C144.665 8.94815 144.597 9.11003 144.597 9.32194V9.49853C144.597 9.71044 144.659 9.87231 144.783 9.98415C144.906 10.096 145.092 10.1519 145.339 10.1519ZM145.339 20.5178C145.48 20.5178 145.604 20.4648 145.71 20.3589C145.816 20.2529 145.869 20.1293 145.869 19.988V11.8648C145.869 11.7236 145.819 11.6 145.718 11.494C145.618 11.3881 145.492 11.3351 145.339 11.3351C145.186 11.3351 145.059 11.3881 144.959 11.494C144.859 11.6 144.809 11.7236 144.809 11.8648V19.988C144.809 20.1293 144.859 20.2529 144.959 20.3589C145.059 20.4648 145.186 20.5178 145.339 20.5178ZM152.491 20.6944C153.338 20.6944 154.098 20.4913 154.769 20.0852C155.44 19.679 155.973 19.1198 156.367 18.4075C156.761 17.6953 156.959 16.8918 156.959 15.9971C156.959 15.0906 156.761 14.2841 156.367 13.5778C155.973 12.8714 155.44 12.3122 154.769 11.9002C154.098 11.4881 153.338 11.2821 152.491 11.2821C151.655 11.2821 150.898 11.4881 150.222 11.9002C149.545 12.3122 149.009 12.8714 148.615 13.5778C148.22 14.2841 148.023 15.0906 148.023 15.9971C148.023 16.8918 148.22 17.6953 148.615 18.4075C149.009 19.1198 149.545 19.679 150.222 20.0852C150.898 20.4913 151.655 20.6944 152.491 20.6944ZM152.491 19.7055C151.843 19.7055 151.263 19.5436 150.751 19.2199C150.239 18.8961 149.833 18.4576 149.533 17.9043C149.233 17.3509 149.083 16.7152 149.083 15.9971C149.083 15.2789 149.233 14.6403 149.533 14.0811C149.833 13.5219 150.239 13.0804 150.751 12.7566C151.263 12.4329 151.843 12.271 152.491 12.271C153.15 12.271 153.736 12.4329 154.248 12.7566C154.76 13.0804 155.163 13.5219 155.457 14.0811C155.752 14.6403 155.899 15.2789 155.899 15.9971C155.899 16.7152 155.752 17.3509 155.457 17.9043C155.163 18.4576 154.76 18.8961 154.248 19.2199C153.736 19.5436 153.15 19.7055 152.491 19.7055ZM166.035 20.5178C166.177 20.5178 166.3 20.4648 166.406 20.3589C166.512 20.2529 166.565 20.1293 166.565 19.988V14.7963C166.565 14.1488 166.462 13.5572 166.256 13.0215C166.05 12.4859 165.714 12.062 165.249 11.7501C164.784 11.4381 164.163 11.2821 163.386 11.2821C162.963 11.2821 162.542 11.3616 162.124 11.5205C161.706 11.6794 161.326 11.8972 160.985 12.1739C160.643 12.4505 160.364 12.7625 160.146 13.1098L160.19 13.0442V12.0768C160.19 11.9708 160.162 11.8748 160.106 11.7887L160.04 11.7059C159.94 11.6 159.813 11.547 159.66 11.547C159.507 11.547 159.381 11.6 159.281 11.7059C159.181 11.8119 159.131 11.9355 159.131 12.0768V19.988C159.131 20.1293 159.178 20.2529 159.272 20.3589C159.366 20.4648 159.496 20.5178 159.66 20.5178C159.802 20.5178 159.925 20.4648 160.031 20.3589C160.137 20.2529 160.19 20.1293 160.19 19.988V14.8492C160.19 14.3783 160.331 13.9486 160.614 13.5601C160.896 13.1716 161.264 12.8596 161.718 12.6242C162.171 12.3887 162.651 12.271 163.157 12.271C163.722 12.271 164.178 12.3887 164.525 12.6242C164.873 12.8596 165.123 13.1716 165.276 13.5601C165.429 13.9486 165.506 14.3783 165.506 14.8492V19.988C165.506 20.1293 165.553 20.2529 165.647 20.3589C165.741 20.4648 165.87 20.5178 166.035 20.5178Z",
    fill: "#5A5C66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2344 19.0272H81.4773V12.7753H81.2344V19.0272Z",
    fill: "#5A5C66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4876 18.0015C48.9624 17.445 49.2 16.7501 49.2 15.9158C49.2 15.0815 48.9653 14.3894 48.496 13.8389C48.0268 13.2888 47.4157 13.0134 46.6627 13.0134C45.9093 13.0134 45.2954 13.2888 44.8205 13.8389C44.3451 14.3894 44.1078 15.0815 44.1078 15.9158C44.1078 16.7501 44.3451 17.445 44.8205 18.0015C45.2954 18.5576 45.9093 18.8355 46.6627 18.8355C47.4038 18.8355 48.0121 18.5576 48.4876 18.0015ZM49.0956 11.7186C49.7446 12.13 50.2572 12.7004 50.6339 13.4307C51.01 14.1606 51.1988 14.989 51.1988 15.9158C51.1988 16.8427 51.0131 17.6742 50.6427 18.4097C50.2716 19.1459 49.7649 19.7192 49.1216 20.1306C48.4789 20.5416 47.7689 20.7473 46.9928 20.7473C46.4367 20.7473 45.9124 20.6345 45.4201 20.4085C44.9271 20.1828 44.5189 19.9074 44.1947 19.5832V19.6873C44.1947 19.9886 44.0959 20.2409 43.899 20.4435C43.7021 20.6457 43.4532 20.7473 43.1519 20.7473C42.8505 20.7473 42.6014 20.6489 42.4045 20.4519C42.2072 20.255 42.1094 20.0002 42.1094 19.6873V8.77266C42.1094 8.47163 42.2072 8.21968 42.4045 8.0168C42.6014 7.81424 42.8505 7.71265 43.1519 7.71265C43.4532 7.71265 43.7021 7.81424 43.899 8.0168C44.0959 8.21968 44.1947 8.47163 44.1947 8.77266V12.4054C44.4726 12.0574 44.8605 11.7536 45.3591 11.4929C45.8571 11.2322 46.3785 11.1018 46.9231 11.1018C47.7227 11.1018 48.4467 11.3075 49.0956 11.7186Z",
    fill: "#5A5C66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9648 18.6093C53.9648 18.3082 54.1149 18.0532 54.4165 17.8447C54.5788 17.7403 54.747 17.6881 54.9208 17.6881C55.164 17.6881 55.3956 17.7984 55.6157 18.0185C55.9636 18.3776 56.3253 18.644 56.7019 18.8178C57.0783 18.9916 57.5331 19.0785 58.0661 19.0785C58.9701 19.0438 59.4219 18.7021 59.4219 18.0532C59.4219 17.7171 59.2684 17.462 58.9611 17.2882C58.6544 17.1147 58.1765 16.9409 57.5275 16.7671C56.8554 16.5818 56.3078 16.3961 55.8851 16.2107C55.4622 16.0257 55.0971 15.7443 54.7904 15.368C54.4831 14.9916 54.3296 14.4846 54.3296 13.8472C54.3296 13.2911 54.4888 12.8075 54.8076 12.3961C55.1261 11.985 55.5431 11.6662 56.0589 11.4402C56.5744 11.2142 57.1221 11.1013 57.7013 11.1013C58.2924 11.1013 58.8829 11.2114 59.4741 11.4314C60.0652 11.6518 60.5281 11.9763 60.8642 12.4048C61.0148 12.5902 61.0905 12.7987 61.0905 13.0304C61.0905 13.3645 60.9173 13.6249 60.5725 13.814C60.5291 13.8378 60.4781 13.855 60.4294 13.8628C60.0696 13.9209 59.786 13.8465 59.5781 13.6387C59.3696 13.3839 59.1005 13.181 58.7701 13.0304C58.44 12.88 58.0661 12.8047 57.6491 12.8047C56.7685 12.8047 56.3284 13.1232 56.3284 13.7603C56.3284 14.0153 56.409 14.2207 56.5716 14.3773C56.7335 14.5336 56.9395 14.6552 57.1887 14.7421C57.4375 14.829 57.7882 14.9363 58.2402 15.0638C58.8657 15.2376 59.3872 15.4173 59.8045 15.6027C60.2215 15.7881 60.5747 16.0719 60.8642 16.4542C61.154 16.8365 61.299 17.3404 61.299 17.9663C61.299 18.5339 61.1308 19.0294 60.7951 19.452C60.4587 19.8753 60.0274 20.197 59.5 20.4167C58.973 20.6368 58.4312 20.7468 57.8751 20.7468C57.1105 20.7468 56.3978 20.6193 55.7376 20.3645C55.0771 20.1097 54.5381 19.6984 54.1211 19.1307C54.0167 18.9916 53.9648 18.8178 53.9648 18.6093Z",
    fill: "#5A5C66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.8802 18.0102C71.3553 17.46 71.5926 16.7676 71.5926 15.933C71.5926 15.099 71.3553 14.4038 70.8802 13.8477C70.4047 13.2916 69.7911 13.0137 69.0377 13.0137C68.2959 13.0137 67.6879 13.2916 67.2131 13.8477C66.7376 14.4038 66.5004 15.099 66.5004 15.933C66.5004 16.7676 66.7348 17.46 67.2044 18.0102C67.6736 18.5604 68.2844 18.8358 69.0377 18.8358C69.7911 18.8358 70.4047 18.5604 70.8802 18.0102ZM73.2959 8.00805C73.4926 8.2053 73.5913 8.46007 73.5913 8.77266V19.5135C73.5913 19.8148 73.4926 20.0671 73.2959 20.2694C73.0987 20.4722 72.8499 20.5735 72.5485 20.5735C72.2472 20.5735 72.0012 20.4754 71.8102 20.2781C71.6185 20.0812 71.5169 19.8323 71.5057 19.531C71.1384 19.9568 70.6089 20.3034 69.9164 20.5707C69.7264 20.6442 69.5257 20.6945 69.3231 20.7167C68.3044 20.8289 67.3979 20.6335 66.6045 20.1306C65.9555 19.7192 65.4429 19.1487 65.0665 18.4185C64.6898 17.6886 64.502 16.8602 64.502 15.933C64.502 15.0065 64.687 14.1753 65.0578 13.4391C65.4288 12.7036 65.9355 12.13 66.5785 11.7189C67.2215 11.3075 67.9311 11.1018 68.7076 11.1018C69.2637 11.1018 69.7852 11.2031 70.2719 11.406C70.7583 11.6085 71.1696 11.8664 71.5057 12.1793V8.77266C71.5057 8.47163 71.6038 8.21968 71.8011 8.0168C71.998 7.81424 72.2472 7.71265 72.5485 7.71265C72.8499 7.71265 73.0987 7.81143 73.2959 8.00805Z",
    fill: "#5A5C66"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4258 12.293V12.2854L13.5944 12.2567L13.5989 12.2619L13.5775 12.3255L13.5733 12.3279L13.4258 12.293Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5963 12.2606L13.4277 12.2893L13.5749 12.3242L13.5963 12.2606Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6016 18.2027L15.6468 18.1529L15.6517 18.1522L15.7069 18.185L15.7056 18.192L15.6054 18.2092L15.6016 18.2027Z",
    fill: "#488C52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6055 18.2046L15.7057 18.1876L15.6504 18.1552L15.6055 18.2046Z",
    fill: "#488C52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7266 16.9634L17.0904 16.5634L17.0966 16.5672L17.0188 16.8024L16.7314 16.9693L16.7266 16.9634Z",
    fill: "#316B51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0158 16.8016L17.0943 16.5663L16.7305 16.9664L17.0158 16.8016Z",
    fill: "#316B51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9045 18.5951L13.8789 18.497L13.882 18.4922L14.1588 18.4452L14.1615 18.4524L13.9103 18.5976L13.9045 18.5951Z",
    fill: "#9B5E45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8828 18.4961L13.9087 18.5942L14.1599 18.4491L13.8828 18.4961Z",
    fill: "#9B5E45"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6559 14.4819L17.4766 13.8058L17.4821 13.8016L17.9267 14.0635L17.9285 14.068L17.7564 14.5862L17.7498 14.5876L17.6559 14.4819Z",
    fill: "#665E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6571 14.4803L17.7508 14.586L17.9235 14.0678L17.4785 13.8055L17.6571 14.4803Z",
    fill: "#665E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3301 11.7931L16.8645 11.4843L16.8701 11.4867L16.9257 11.6953L16.9226 11.7002L16.3325 11.8004L16.3301 11.7931Z",
    fill: "#9A5E42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9221 11.6949L16.8668 11.4862L16.332 11.7951L16.9221 11.6949Z",
    fill: "#9A5E42"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.627 12.2027L15.4062 11.9546L15.4083 11.948L16.3297 11.7919L16.3325 11.7991L15.6319 12.2033L15.627 12.2027Z",
    fill: "#4B8A4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3316 11.7958L15.4102 11.9523L15.6313 12.2003L16.3316 11.7958Z",
    fill: "#4B8A4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6424 13.766L19.6406 13.7594L22.3568 10.7713L29.0538 9.63464L29.0583 9.6381V9.85092L21.5142 14.2089L21.5114 14.2092L19.6424 13.766Z",
    fill: "#7F7272"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6445 13.7619L21.5133 14.2052L29.0556 9.85064V9.63782L22.3611 10.7734L19.6445 13.7619Z",
    fill: "#7F7272"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48714 9.4613L1.48438 9.4575V7.7197C1.48438 7.35106 1.68268 7.00696 2.00226 6.82247L3.71001 5.83679L3.7145 5.83748L8.38721 11.0903L8.38341 11.0965L1.48714 9.4613Z",
    fill: "#FBD828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71184 5.8407L2.00479 6.82637C1.68521 7.01086 1.48828 7.35186 1.48828 7.7205V9.45795L8.38456 11.0935L3.71184 5.8407Z",
    fill: "#FBD828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5519 24.4845L21.7344 19.0689L21.7382 19.0624L29.0546 20.7974L29.0577 20.8012V22.443C29.0577 22.812 28.8594 23.1561 28.5394 23.3405L26.557 24.4851L26.5519 24.4845Z",
    fill: "#FBD828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5558 24.4802L28.5385 23.3356C28.8577 23.1511 29.0547 22.8101 29.0547 22.4415V20.7994L21.7383 19.0643L26.5558 24.4802Z",
    fill: "#FBD828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00226 23.3402C1.68268 23.1557 1.48438 22.8116 1.48438 22.4426V20.5991L1.48748 20.5953L8.12983 19.4686L8.13363 19.4748L3.72141 24.3289L3.71657 24.3296L2.00226 23.3402Z",
    fill: "#D27371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48828 20.5982V22.4417C1.48828 22.8103 1.68486 23.1513 2.00444 23.3358L3.71875 24.3257L8.13097 19.4716L1.48828 20.5982Z",
    fill: "#D27371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3574 10.7707L26.8374 5.84237L26.8418 5.84167L28.5403 6.82251C28.8602 7.00666 29.0585 7.35076 29.0585 7.71974V9.63789L29.0557 9.64169L22.3612 10.7773L22.3574 10.7707Z",
    fill: "#D27371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5377 6.82607L26.839 5.84558L22.3594 10.7736L29.0539 9.63834V7.7202C29.0539 7.35156 28.857 7.01056 28.5377 6.82607Z",
    fill: "#D27371"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60875 14.2974L1.48679 14.2688L1.48438 14.265V9.81681L1.4899 9.81335L7.41916 13.3052L7.41778 13.3125L1.61048 14.2974H1.60875Z",
    fill: "#93C64B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48828 9.81531V14.2635L1.61024 14.2921L7.41754 13.3071L1.48828 9.81531Z",
    fill: "#93C64B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8594 16.9773L22.8608 16.97L28.8809 15.9491L29.056 15.9902L29.0588 15.994V20.6215L29.0533 20.6249L22.8594 16.9773Z",
    fill: "#8EC54C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0533 20.6216V15.9941L28.8795 15.953L22.8594 16.9739L29.0533 20.6216Z",
    fill: "#8EC54C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7367 19.0684L20.2656 17.4156L20.2677 17.4091L22.8599 16.9696L29.0562 20.6176L29.0579 20.7997L29.0534 20.8031L21.7367 19.0684Z",
    fill: "#93C34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2695 17.4139L21.7389 19.0654L29.0556 20.8004V20.6218L22.8617 16.9745L20.2695 17.4139Z",
    fill: "#93C34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41536 13.312L1.4861 9.82014L1.48438 9.45876L1.48921 9.45496L8.38514 11.0901L9.97197 12.8732L9.97024 12.8798L7.41812 13.3123L7.41536 13.312Z",
    fill: "#93C34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96965 12.8741L8.38456 11.0921L1.48828 9.45691V9.81518L7.41754 13.307L9.96965 12.8741Z",
    fill: "#93C34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.64235 27.1732L8.64062 27.1687L9.32573 25.1061L14.2075 19.7345L14.2144 19.7362L15.0259 22.8017L12.7827 29.5584L12.7771 29.5605L8.64235 27.1732Z",
    fill: "#FBD828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33124 25.1061L8.64648 27.1687L12.7809 29.556L15.0242 22.8017L14.2126 19.7362L9.33124 25.1061Z",
    fill: "#FBD828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5271 10.2323L15.5234 6.44092L17.5083 0.461912L17.5138 0.459839L21.6486 2.84716L21.6503 2.85165L20.7334 5.61313L16.5336 10.234L16.5271 10.2323Z",
    fill: "#FBD828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7304 5.61059L21.6473 2.84911L17.5125 0.461792L15.5273 6.43873L16.5313 10.2301L20.7304 5.61059Z",
    fill: "#FBD828"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.84766 24.4041V24.3972L10.9163 20.3163L10.9219 20.3211L9.33227 25.1072L7.86637 26.7206L7.86153 26.7216L3.84766 24.4041Z",
    fill: "#F6B331"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85156 24.4011L7.86509 26.7186L9.33065 25.1066L10.9199 20.3202L3.85156 24.4011Z",
    fill: "#F6B331"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2305 10.1194L20.7278 5.61041L22.6905 3.45076L22.695 3.45007L26.7393 5.78522V5.79179L19.236 10.1239L19.2305 10.1194Z",
    fill: "#F4AA34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.738 5.78718L22.6934 3.45203L20.7317 5.61029L19.2344 10.1192L26.738 5.78718Z",
    fill: "#F4AA34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.85073 24.4053L3.71979 24.3296L3.71875 24.3237L8.13132 19.4697L11.3858 18.9169L11.3896 18.9217L10.9249 20.3223L3.85487 24.4053H3.85073Z",
    fill: "#E16239"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3837 18.9198L8.13132 19.4715L3.71875 24.3253L3.85004 24.401L10.9184 20.3201L11.3837 18.9198Z",
    fill: "#E16239"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8145 11.3733L19.2311 10.1188L26.7365 5.7843L26.8405 5.84234L26.8415 5.84822L22.3619 10.7766L18.8189 11.3784L18.8145 11.3733Z",
    fill: "#E16239"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8184 11.3748L22.3589 10.774L26.8389 5.84601L26.7387 5.78796L19.235 10.12L18.8184 11.3748Z",
    fill: "#E16239"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32812 25.1062L10.9177 20.3198L13.9089 18.5917L13.9145 18.5941L14.2168 19.7363L9.33469 25.11L9.32812 25.1062Z",
    fill: "#F8A832"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9092 18.5946L10.9193 20.3207L9.33008 25.107L14.2115 19.7368L13.9092 18.5946Z",
    fill: "#F8A832"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.862 11.4885L16.5293 10.2312L20.729 5.60828L20.7356 5.61208L19.2383 10.121L16.8679 11.4909L16.862 11.4885Z",
    fill: "#F4AA34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8659 11.4879L19.2349 10.1202L20.7323 5.61121L16.5332 10.2307L16.8659 11.4879Z",
    fill: "#F4AA34"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.916 20.321L11.381 18.9207L11.3838 18.9179L13.8827 18.494L13.8872 18.4971L13.9131 18.5949L13.911 18.5994L10.9215 20.3254L10.916 20.321Z",
    fill: "#E05B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3853 18.9199L10.9199 20.3201L13.9101 18.5941L13.8839 18.496L11.3853 18.9199Z",
    fill: "#E05B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9147 11.6977L16.8594 11.489L16.8611 11.4845L19.2301 10.1171L19.2356 10.1216L18.8193 11.376L18.8162 11.3788L16.9191 11.7004L16.9147 11.6977Z",
    fill: "#E05B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8195 11.3748L19.2362 10.12L16.8672 11.4878L16.9225 11.6965L18.8195 11.3748Z",
    fill: "#E05B39"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9335 30.0339L15.0195 22.8029L16.047 19.7073L16.0532 19.7059L20.3121 24.4937L21.1374 27.609L21.1354 27.6135L16.9394 30.0364L16.9335 30.0339Z",
    fill: "#8EC54C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0234 22.8033L16.9374 30.0344L21.1341 27.6115L20.3097 24.4976L16.0509 19.7098L15.0234 22.8033Z",
    fill: "#8EC54C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7679 6.74074L9.625 2.42595L9.62707 2.42181L13.8234 -0.00109863L13.8289 0.00131978L15.5328 6.4381L14.1671 10.5532L14.1606 10.5546L10.7679 6.74074Z",
    fill: "#8DC64D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5291 6.43849L13.8252 0.00170898L9.62891 2.42427L10.7707 6.73733L14.1634 10.5515L15.5291 6.43849Z",
    fill: "#8DC64D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1883 11.7088L14.1612 10.5539L14.1602 10.5501L15.5262 6.43738H15.5335L16.5371 10.2288L15.1942 11.7088H15.1883Z",
    fill: "#93C34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1915 11.7071L16.5338 10.2308L15.5298 6.43945L14.1641 10.5525L15.1915 11.7071Z",
    fill: "#93C34A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0186 22.8035L14.207 19.7377L15.1495 18.6981H15.1554L16.0523 19.7066L16.053 19.7104L15.0258 22.8035H15.0186Z",
    fill: "#A0B447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1527 18.701L14.2109 19.7372L15.0225 22.8027L16.05 19.7092L15.1527 18.701Z",
    fill: "#A0B447"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4065 11.9558L15.1875 11.7102L15.1878 11.7047L16.5297 10.2284L16.5366 10.2301L16.869 11.4874L16.8676 11.4915L16.3328 11.8004L15.41 11.9569L15.4065 11.9558Z",
    fill: "#A19542"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3296 11.7971L16.8644 11.4882L16.5317 10.2313L15.1895 11.7076L15.4081 11.9536L16.3296 11.7971Z",
    fill: "#A19542"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2089 19.7374L13.9062 18.5952L13.9083 18.5907L14.1591 18.4456L14.8294 18.3319L15.1573 18.6978L15.1569 18.703L14.2155 19.7387L14.2089 19.7374Z",
    fill: "#9F9542"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1594 18.4494L13.9082 18.5945L14.2105 19.7367L15.1523 18.7009L14.8279 18.3361L14.1594 18.4494Z",
    fill: "#9F9542"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4147 26.8706L20.3048 24.4988L19.1758 20.2355L19.1817 20.2313L26.4721 24.5247V24.5313L22.4196 26.8712L22.4147 26.8706Z",
    fill: "#5BBCB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.308 24.4958L22.4176 26.8676L26.4705 24.5276L19.1797 20.2343L20.308 24.4958Z",
    fill: "#5BBCB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.83203 5.77382V5.76726L7.84521 3.45007L7.8504 3.45076L10.7725 6.73601L11.7506 10.4296L11.7447 10.4338L3.83203 5.77382Z",
    fill: "#5BBCB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7693 6.7379L7.84717 3.453L3.83398 5.76984L11.7467 10.4301L10.7693 6.7379Z",
    fill: "#5BBCB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.4696 24.5322L19.1788 20.2385L18.6758 18.3418L18.6803 18.3369L21.7375 19.0617L26.557 24.4786L26.556 24.4845L26.4738 24.5322H26.4696Z",
    fill: "#64BA51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6797 18.3407L19.181 20.2354L26.4718 24.5291L26.5544 24.4814L21.7369 19.0655L18.6797 18.3407Z",
    fill: "#64BA51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38378 11.0979L3.70898 5.84405L3.71002 5.83818L3.83198 5.7677H3.83612L11.7488 10.428L12.1627 11.9882L12.1586 11.993L8.38378 11.0979Z",
    fill: "#64BA51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1601 11.9888L11.7479 10.4307L3.83485 5.77039L3.71289 5.84121L8.38526 11.0937L12.1601 11.9888Z",
    fill: "#64BA51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6791 18.3442L18.6763 18.3415L18.5098 17.7123L18.5129 17.7075L20.2673 17.41L21.7397 19.0628L21.7363 19.0694L18.6791 18.3442Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6782 18.3405L21.7355 19.0654L20.2661 17.4139L18.5117 17.7114L18.6782 18.3405Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96596 12.8778L8.38086 11.0958L8.38466 11.0896L12.1595 11.9848L12.1619 11.9875L12.2928 12.4809L12.2897 12.4857L9.96976 12.8789L9.96596 12.8778Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1615 11.9888L8.38672 11.0936L9.97216 12.8757L12.2925 12.4821L12.1615 11.9888Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7447 10.4333L10.7656 6.73903L10.7725 6.73523L14.1652 10.5491L14.1659 10.5532L13.8045 11.6412L13.799 11.6429L11.7447 10.4333Z",
    fill: "#43B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8008 11.6399L14.1622 10.552L10.7695 6.73816L11.7469 10.43L13.8008 11.6399Z",
    fill: "#43B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0476 19.7117L16.0469 19.7079L16.4131 18.6055L16.4183 18.6034L19.1832 20.2317L20.3133 24.4957L20.3064 24.4991L16.0476 19.7117Z",
    fill: "#43B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.417 18.6083L16.0508 19.7107L20.31 24.4981L19.1816 20.2366L16.417 18.6083Z",
    fill: "#43B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4138 18.6095L16.4121 18.605L16.6021 18.0329L16.6052 18.0301L17.062 17.9528L18.6799 18.3359L18.6827 18.3387L19.1843 20.2333L19.1784 20.2378L16.4138 18.6095Z",
    fill: "#2FA955"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.608 18.0346L16.418 18.6068L19.1826 20.2351L18.6813 18.3404L17.0647 17.9569L16.608 18.0346Z",
    fill: "#2FA955"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4286 12.2932L12.1614 11.9927L12.1583 11.9899L11.7461 10.4318L11.7516 10.4276L13.8059 11.6372L13.8076 11.6417L13.6017 12.2622L13.5986 12.2646L13.43 12.2932H13.4286Z",
    fill: "#2CAE55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5964 12.2606L13.8023 11.6404L11.748 10.4305L12.1606 11.9887L13.4278 12.2893L13.5964 12.2606Z",
    fill: "#2CAE55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2868 12.4831L12.1562 11.9897L12.1611 11.9852L13.4283 12.2855L13.428 12.2931L12.2913 12.4858L12.2868 12.4831Z",
    fill: "#2CAC55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4274 12.2887L12.1602 11.9882L12.2911 12.4815L13.4274 12.2887Z",
    fill: "#2CAC55"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0625 17.9604V17.9528L18.5122 17.7068L18.5167 17.7096L18.6832 18.3387L18.6787 18.3435L17.0625 17.9604Z",
    fill: "#2AA454"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0625 17.9574L18.679 18.3406L18.5122 17.7118L17.0625 17.9574Z",
    fill: "#2AA454"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1504 18.7031V18.6979L15.6016 18.2018L15.7042 18.1835L16.4183 18.6032L16.4201 18.6077L16.0538 19.7102L16.0476 19.7112L15.1504 18.7031Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6036 18.2043L15.1523 18.7008L16.0496 19.7089L16.4158 18.6065L15.7037 18.1874L15.6036 18.2043Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.574 12.0978L13.8025 11.6435L13.8008 11.639L14.1618 10.5507L14.1684 10.5497L15.1959 11.7043L15.1955 11.7095L14.8915 12.0439L14.5767 12.0982L14.574 12.0978Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8856 12.041L15.1896 11.7066L14.1622 10.5516L13.8008 11.6396L14.5729 12.0942L14.8856 12.041Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7031 18.1911L15.7045 18.1838L16.6062 18.0311L16.6104 18.036L16.4204 18.6084L16.4152 18.6102L15.7031 18.1911Z",
    fill: "#2CA855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7031 18.1871L16.4152 18.6062L16.6048 18.0341L15.7031 18.1871Z",
    fill: "#2CA855"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5918 12.2592L13.7981 11.639L13.8032 11.6366L14.5751 12.0913L14.574 12.0982L13.5963 12.264L13.5918 12.2592Z",
    fill: "#32A854"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5754 12.0948L13.8036 11.6405L13.5977 12.2607L14.5754 12.0948Z",
    fill: "#32A854"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1502 18.7047L14.8262 18.3399L14.8282 18.3337L15.6035 18.202L15.607 18.2086L15.1561 18.7047H15.1502Z",
    fill: "#498B4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8281 18.3366L15.1525 18.7014L15.6037 18.205L14.8281 18.3366Z",
    fill: "#498B4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8828 12.0385L15.1872 11.7041H15.1927L15.4114 11.9497L15.409 11.9563L14.8866 12.0451L14.8828 12.0385Z",
    fill: "#488C51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4075 11.9529L15.1888 11.7069L14.8848 12.0413L15.4075 11.9529Z",
    fill: "#488C51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8813 15.9564L21.5128 14.209L21.5117 14.2021L29.0537 9.84753L29.0596 9.85099V15.9233L29.0565 15.9271L28.8827 15.9564H28.8813Z",
    fill: "#5BBCB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8822 15.9526L29.056 15.9232V9.85059L21.5137 14.2051L28.8822 15.9526Z",
    fill: "#5BBCB8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48438 20.3648V14.3132L1.48748 14.3098L1.6091 14.2891L8.97938 16.0365L8.98042 16.0434L1.49025 20.3679L1.48438 20.3648Z",
    fill: "#42BFBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.61024 14.2927L1.48828 14.3135V20.3647L8.9788 16.0402L1.61024 14.2927Z",
    fill: "#42BFBE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48438 20.5988V20.3653L1.4861 20.3618L8.97696 16.037L10.8485 16.4799L10.8499 16.4861L8.13363 19.4746L1.48887 20.6026L1.48438 20.5988Z",
    fill: "#7F7272"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8475 16.4832L8.9788 16.0399L1.48828 20.3647V20.5983L8.13097 19.4716L10.8475 16.4832Z",
    fill: "#7F7272"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8577 16.977L19.8164 15.186V15.1794L21.5093 14.202L28.881 15.9488L28.8806 15.9564L22.8605 16.9773L22.8577 16.977Z",
    fill: "#43B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8577 16.9733L28.8779 15.9521L21.5093 14.205L19.8164 15.182L22.8577 16.9733Z",
    fill: "#43B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.60938 14.2972L1.60972 14.2895L7.41737 13.3046L10.5354 15.1398V15.1467L8.98104 16.0443L8.97793 16.0446L1.60938 14.2972Z",
    fill: "#43B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5342 15.1424L7.41863 13.3075L1.61133 14.2925L8.97989 16.04L10.5342 15.1424Z",
    fill: "#43B556"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5339 15.1468L7.41797 13.3119L7.41935 13.3046L9.97147 12.8721L11.4992 14.5864L11.4982 14.5926L10.5377 15.1468H10.5339Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.97008 12.876L7.41797 13.3089L10.5336 15.1438L11.494 14.5892L9.97008 12.876Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2639 17.4163L18.8008 15.771L18.8018 15.7652L19.8158 15.1796H19.8196L22.8613 16.9706L22.8599 16.9778L20.2677 17.4173L20.2639 17.4163Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8047 15.7681L20.2682 17.4133L22.8604 16.9735L19.8194 15.1825L18.8047 15.7681Z",
    fill: "#2DB256"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.816 15.1872L18.8601 14.6244L18.8594 14.6185L19.6388 13.7607L19.6429 13.7596L21.5117 14.2029L21.5127 14.2098L19.8198 15.1872H19.816Z",
    fill: "#5D7252"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8192 15.1829L21.5118 14.2055L19.643 13.7626L18.8633 14.6201L19.8192 15.1829Z",
    fill: "#5D7252"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.9776 16.045L8.97656 16.0377L10.5313 15.1405H10.5351L11.5332 15.7282L11.5342 15.7344L10.8501 16.4869L10.8463 16.4883L8.9776 16.045Z",
    fill: "#5D7252"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5348 15.1434L8.98047 16.041L10.8492 16.4839L11.5336 15.7315L10.5348 15.1434Z",
    fill: "#5D7252"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8 15.7722L18.3125 15.2242L18.3128 15.2191L18.8587 14.6186L18.8636 14.6179L19.8188 15.1807V15.1873L18.8048 15.7729L18.8 15.7722Z",
    fill: "#5F6C4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8035 15.7694L19.8182 15.1838L18.8623 14.621L18.3164 15.2214L18.8035 15.7694Z",
    fill: "#5F6C4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5332 15.1469V15.1403L11.4933 14.5858L11.4985 14.5865L12.0309 15.1852L12.0305 15.1901L11.5362 15.7342L11.5317 15.7349L10.5332 15.1469Z",
    fill: "#5F6C4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.028 15.1871L11.4956 14.5887L10.5352 15.1433L11.5336 15.7309L12.028 15.1871Z",
    fill: "#5F6C4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1434 13.4109L18.1406 13.4058L18.8154 11.3736L18.8185 11.3708L22.3594 10.7704L22.3628 10.7766L19.6463 13.7651L19.6425 13.7665L18.1434 13.4109Z",
    fill: "#856349"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1426 13.4076L19.642 13.7631L22.3582 10.7743L18.8177 11.3751L18.1426 13.4076Z",
    fill: "#856349"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.12891 19.4692L10.8451 16.4808L10.8489 16.4794L12.0958 16.7751L12.0986 16.7799L11.3875 18.9213L11.3844 18.924L8.13236 19.4758L8.12891 19.4692Z",
    fill: "#856349"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8494 16.4844L8.13281 19.4728L11.3852 18.9211L12.0959 16.7798L10.8494 16.4844Z",
    fill: "#856349"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9216 14.0707L17.9199 14.0662L18.1393 13.406L18.1438 13.4032L19.6429 13.7591L19.6446 13.7653L18.8652 14.6228L18.8603 14.6238L17.9216 14.0707Z",
    fill: "#64614E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9238 14.0673L18.8625 14.6201L19.6423 13.7626L18.1429 13.4071L17.9238 14.0673Z",
    fill: "#64614E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8458 16.4871L10.8438 16.4806L11.5282 15.7281L11.5327 15.7274L12.2945 16.1762L12.2962 16.1804L12.0972 16.7801L12.0923 16.7829L10.8458 16.4871Z",
    fill: "#66614F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2935 16.1788L11.5321 15.7303L10.8477 16.4828L12.0945 16.7786L12.2935 16.1788Z",
    fill: "#66614F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5323 15.7346L11.5312 15.7287L12.0256 15.1846L12.0315 15.1849L12.4661 15.6734L12.4668 15.6769L12.2996 16.181L12.2941 16.183L11.5323 15.7346Z",
    fill: "#655E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0276 15.1873L11.5332 15.7311L12.2947 16.1798L12.4622 15.6758L12.0276 15.1873Z",
    fill: "#655E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3136 15.2225L17.7487 14.5875L17.748 14.5837L17.9201 14.0651L17.9256 14.0634L18.8647 14.6161L18.8657 14.622L18.3195 15.2225H18.3136Z",
    fill: "#655E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3172 15.2215L18.863 14.621L17.9244 14.0682L17.752 14.5865L18.3172 15.2215Z",
    fill: "#655E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3222 13.2162L17.3191 13.2135L16.918 11.6975L16.9211 11.6926L18.8181 11.371L18.8226 11.3758L18.1476 13.4083L18.1431 13.4107L17.3222 13.2162Z",
    fill: "#846148"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.323 13.2115L18.1439 13.4061L18.8189 11.3739L16.9219 11.6956L17.323 13.2115Z",
    fill: "#846148"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3789 18.919L12.0899 16.7777L12.0944 16.7753L13.5164 17.1125L13.5195 17.1152L13.8851 18.4955L13.882 18.5003L11.3831 18.9242L11.3789 18.919Z",
    fill: "#846148"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5162 17.1167L12.0938 16.7792L11.3828 18.9205L13.8817 18.4969L13.5162 17.1167Z",
    fill: "#846148"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4753 13.81L17.3164 13.2143L17.3212 13.2098L18.1421 13.4043L18.1445 13.4095L17.9255 14.0698L17.92 14.0718L17.4753 13.81Z",
    fill: "#655E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4795 13.8046L17.9241 14.0665L18.1431 13.4063L17.3223 13.2118L17.4795 13.8046Z",
    fill: "#655E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0946 16.7833L12.0918 16.7781L12.2908 16.1787L12.2967 16.1766L13.452 16.8569L13.5218 17.1157L13.5169 17.1205L12.0946 16.7833Z",
    fill: "#675F4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2928 16.1796L12.0938 16.7793L13.5161 17.1165L13.4484 16.8602L12.2928 16.1796Z",
    fill: "#675F4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.2911 16.1836L12.2891 16.1792L12.4566 15.6751L12.4632 15.6737L13.4233 16.753L13.452 16.8598L13.4464 16.8639L12.2911 16.1836Z",
    fill: "#625C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4226 16.7548L12.4625 15.6755L12.2949 16.1793L13.4506 16.8599L13.4226 16.7548Z",
    fill: "#625C4C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1602 18.4465L14.6687 18.1532L14.6732 18.1539L14.8335 18.3339L14.8311 18.3401L14.1629 18.4538L14.1602 18.4465Z",
    fill: "#468C54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1602 18.4494L14.8287 18.3361L14.6687 18.1561L14.1602 18.4494Z",
    fill: "#468C54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8792 18.4972L13.5137 17.117L13.5182 17.1122L13.8046 17.1802L14.6711 18.1531L14.67 18.159L14.1618 18.4527L13.8837 18.5L13.8792 18.4972Z",
    fill: "#675F4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8036 17.185L13.5176 17.1173L13.8828 18.4972L14.1598 18.4502L14.6684 18.1569L13.8036 17.185Z",
    fill: "#675F4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3169 12.9778L15.627 12.2032L15.628 12.1974L16.3286 11.7928L16.9198 11.6923L16.9243 11.695L17.3254 13.211L17.3209 13.2159L16.3169 12.9778Z",
    fill: "#655E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3168 12.9741L17.3204 13.2122L16.9193 11.6962L16.3292 11.7964L15.6289 12.2009L16.3168 12.9741Z",
    fill: "#655E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5908 13.2876L16.3145 12.9774L16.3186 12.9708L17.3222 13.2089L17.325 13.2116L17.4822 13.8048L17.4763 13.809L16.5908 13.2876Z",
    fill: "#4F614F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5957 13.2831L17.4812 13.8044L17.324 13.2116L16.3203 12.9735L16.5957 13.2831Z",
    fill: "#4F614F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5161 17.1209L13.5134 17.1181L13.4453 16.8614L13.4512 16.8573L13.589 16.9385L13.8063 17.1824L13.8025 17.1886L13.5161 17.1209Z",
    fill: "#535F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5887 16.9413L13.4512 16.8601L13.5189 17.1168L13.805 17.1845L13.5887 16.9413Z",
    fill: "#535F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5898 13.2861L16.5947 13.2803L17.4798 13.802L17.6605 14.4788L17.6536 14.4822L16.5898 13.2861Z",
    fill: "#4F5F4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6579 14.4801L17.4792 13.8054L16.5938 13.2841L17.6579 14.4801Z",
    fill: "#4F5F4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4477 16.8636L13.418 16.7561L13.4249 16.7527L13.59 16.9389L13.5852 16.9448L13.4477 16.8636Z",
    fill: "#4D5E4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4499 16.8598L13.5874 16.941L13.4219 16.7548L13.4499 16.8598Z",
    fill: "#4D5E4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4907 14.5914L9.9668 12.8781L9.96922 12.8716L12.2895 12.4784L12.2937 12.4812L12.6716 13.9097L12.6699 13.9142L11.4959 14.5921L11.4907 14.5914Z",
    fill: "#2DA956"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.669 13.9103L12.291 12.4813L9.9707 12.8748L11.495 14.5881L12.669 13.9103Z",
    fill: "#2DA956"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0246 15.1896L11.4922 14.5912L11.4932 14.585L12.6675 13.9071L12.6731 13.9095L12.7902 14.3514L12.0305 15.1896H12.0246Z",
    fill: "#3C6B53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6681 13.91L11.4941 14.5879L12.0265 15.1866L12.7852 14.3516L12.6681 13.91Z",
    fill: "#3C6B53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1026 16.1732L17.9551 15.6166L18.3147 15.2186H18.3206L18.8077 15.7666L18.8067 15.7724L18.1085 16.1756L18.1026 16.1732Z",
    fill: "#3A6B52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.957 15.6161L18.1046 16.1727L18.8028 15.7695L18.3156 15.2216L17.957 15.6161Z",
    fill: "#3A6B52"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9542 15.6159L17.7109 14.6969L17.7479 14.5843L17.7545 14.5829L18.3193 15.2179V15.2231L17.9611 15.6176L17.9542 15.6159Z",
    fill: "#4B6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9577 15.6152L18.3163 15.2207L17.7511 14.5857L17.7148 14.6962L17.9577 15.6152Z",
    fill: "#4B6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0234 15.1894V15.1842L12.7825 14.3495L12.789 14.3512L12.8402 14.5443L12.4646 15.6765L12.4584 15.6779L12.0234 15.1894Z",
    fill: "#4C6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8375 14.5449L12.7864 14.3514L12.0273 15.1865L12.462 15.675L12.8375 14.5449Z",
    fill: "#4C6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7113 14.6971L17.6543 14.4809L17.6609 14.4774L17.7548 14.5828L17.7555 14.5866L17.7186 14.6971H17.7113Z",
    fill: "#665E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7499 14.5851L17.6562 14.4794L17.7136 14.6956L17.7499 14.5851Z",
    fill: "#665E4E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4577 15.6777L12.457 15.6739L12.8322 14.5438L12.8395 14.5442L13.4244 16.7536L13.4178 16.757L12.4577 15.6777Z",
    fill: "#4C5D4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4609 15.6749L13.421 16.7542L12.8365 14.5448L12.4609 15.6749Z",
    fill: "#4C5D4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6654 13.9116L12.2871 12.4827L12.2906 12.4782L13.4269 12.285L13.5761 12.3203L13.5789 12.3251L13.1418 13.6411L12.6713 13.914L12.6654 13.9116Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5768 12.3232L13.4293 12.288L12.293 12.4811L12.6709 13.9097L13.1398 13.6392L13.5768 12.3232Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5092 17.7117L18.1016 16.1722L18.1033 16.1677L18.8022 15.7645L18.8067 15.7656L20.2705 17.4104L20.2681 17.4166L18.5137 17.7145L18.5092 17.7117Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1055 16.1727L18.5131 17.7122L20.2675 17.4147L18.8037 15.7695L18.1055 16.1727Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6016 18.0341L16.6586 17.8617L16.6634 17.8593L17.0631 17.9539L17.0628 17.9615L16.6061 18.0389L16.6016 18.0341Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6055 18.0346L17.0622 17.9568L16.6625 17.8622L16.6055 18.0346Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.063 17.9612L16.6633 17.8662L16.6602 17.8614L17.0126 16.8L18.1039 16.1688L18.1095 16.1709L18.5172 17.7104L18.514 17.7152L17.0644 17.9612H17.063Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6641 17.8622L17.0638 17.9569L18.5138 17.7112L18.1061 16.1718L17.0168 16.8009L16.6641 17.8622Z",
    fill: "#2BA856"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7812 14.3531L12.6641 13.9116L12.6661 13.9071L13.1346 13.6366L13.1405 13.6411L12.9702 14.1534L12.7881 14.3549L12.7812 14.3531Z",
    fill: "#3E6C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9668 14.1519L13.1368 13.6395L12.668 13.91L12.7851 14.3516L12.9668 14.1519Z",
    fill: "#3E6C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0117 16.8003L17.0901 16.565L17.9546 15.6132L17.9611 15.6145L18.1086 16.1715L18.1069 16.1756L17.0176 16.8047L17.0117 16.8003Z",
    fill: "#346B51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0941 16.5655L17.0156 16.8008L18.1053 16.1717L17.9578 15.6151L17.0941 16.5655Z",
    fill: "#346B51"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5703 12.0981L14.5717 12.0908L14.8844 12.038L14.8878 12.0442L14.7475 12.199L14.7427 12.1997L14.5703 12.0981Z",
    fill: "#2DA956"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8869 12.0409L14.5742 12.0941L14.7463 12.1953L14.8869 12.0409Z",
    fill: "#2DA956"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7025 18.1909L15.6472 18.1584L15.6465 18.1526L16.0452 17.7138L16.049 17.7128L16.6643 17.8586L16.6671 17.8634L16.6097 18.0358L16.6069 18.0386L15.7052 18.1913L15.7025 18.1909Z",
    fill: "#2AA057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0471 17.7167L15.6484 18.1554L15.7037 18.1879L16.6054 18.0349L16.6624 17.8625L16.0471 17.7167Z",
    fill: "#2AA057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5734 12.3277L13.5703 12.3225L13.5917 12.2593L13.5948 12.2565L14.5726 12.0907L14.747 12.1926L14.7481 12.1985L14.4447 12.5322L14.4413 12.5336L13.5734 12.3277Z",
    fill: "#2AA057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4421 12.5296L14.7454 12.1958L14.5734 12.0946L13.5956 12.2604L13.5742 12.324L14.4421 12.5296Z",
    fill: "#2AA057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1348 13.6386L13.5718 12.3226L13.5763 12.3202L14.4442 12.5258L14.4462 12.5323L13.7636 13.2831L13.1406 13.6431L13.1348 13.6386Z",
    fill: "#289E57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4413 12.5287L13.5734 12.3231L13.1367 13.6391L13.7586 13.2798L14.4413 12.5287Z",
    fill: "#289E57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.047 17.7202L16.0449 17.714L16.7273 16.9632L17.0137 16.7977L17.0192 16.8022L16.6668 17.8636L16.6623 17.866L16.047 17.7202Z",
    fill: "#2AA057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0469 17.7172L16.6622 17.863L17.0149 16.8016L16.7296 16.9664L16.0469 17.7172Z",
    fill: "#2AA057"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9648 14.1513L13.1348 13.6386L13.7591 13.2772L13.764 13.2831L12.9714 14.1551L12.9648 14.1513Z",
    fill: "#3E6C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1387 13.6395L12.9688 14.1518L13.761 13.2802L13.1387 13.6395Z",
    fill: "#3E6C53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0898 16.5639L17.7107 14.6945L17.7179 14.6948L17.9608 15.6138L17.0964 16.5677L17.0898 16.5639Z",
    fill: "#436050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0938 16.5657L17.9575 15.6153L17.7146 14.6963L17.0938 16.5657Z",
    fill: "#436050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8324 14.5469L12.7812 14.3534L12.9637 14.1503L12.9699 14.1541L12.8396 14.5469H12.8324Z",
    fill: "#4C6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7852 14.3509L12.8363 14.5444L12.9669 14.1512L12.7852 14.3509Z",
    fill: "#4C6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8263 18.3384L14.666 18.1584L14.6671 18.1525L15.1632 17.8661H15.167L15.6517 18.1515L15.6527 18.1573L15.6075 18.2071L14.8298 18.3394L14.8263 18.3384Z",
    fill: "#298858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.166 17.87L14.6699 18.1564L14.8299 18.3364L15.6055 18.2048L15.6504 18.1554L15.166 17.87Z",
    fill: "#298858"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1848 12.4597L14.7432 12.1996L14.7422 12.1934L14.8825 12.0389L15.4076 11.9491L15.6318 12.1985L15.6308 12.2044L15.1889 12.4597H15.1848Z",
    fill: "#2A8754"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.188 12.4554L15.6302 12.2001L15.4094 11.952L14.8867 12.0405L14.7461 12.1952L15.188 12.4554Z",
    fill: "#2A8754"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1621 17.8729V17.8663L15.6074 17.6093L16.0483 17.7126L16.0504 17.7191L15.6517 18.1575L15.6465 18.1582L15.1621 17.8729Z",
    fill: "#2A8354"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1641 17.8705L15.6484 18.1559L16.0475 17.7172L15.6094 17.6132L15.1641 17.8705Z",
    fill: "#2A8354"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4415 12.534L14.4395 12.5274L14.7428 12.1941L14.7476 12.1934L15.1895 12.4535V12.4601L14.8824 12.6373L14.8796 12.638L14.4415 12.534Z",
    fill: "#298454"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1886 12.4564L14.7467 12.1963L14.4434 12.5297L14.8814 12.6337L15.1886 12.4564Z",
    fill: "#298454"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6652 18.1586L13.8008 17.1868L13.8046 17.1805L14.1338 17.2586L15.1661 17.8663L15.1658 17.8729L14.67 18.1593L14.6652 18.1586Z",
    fill: "#4B6150"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8047 17.1844L14.6694 18.1563L15.1652 17.8699L14.1343 17.2625L13.8047 17.1844Z",
    fill: "#4B6150"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.896 12.8784L15.1836 12.4594L15.1839 12.4525L15.6262 12.1971L15.6307 12.1982L16.3189 12.9714L16.3151 12.9779L15.896 12.8784Z",
    fill: "#4C6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3176 12.9752L15.6297 12.202L15.1875 12.457L15.8985 12.8757L16.3176 12.9752Z",
    fill: "#4C6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.1637 17.8729L14.1328 17.2659L14.1352 17.2587L15.6122 17.6086L15.6132 17.6159L15.1675 17.8729H15.1637Z",
    fill: "#495D4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1328 17.2628L15.1637 17.8702L15.6091 17.6128L14.1328 17.2628Z",
    fill: "#495D4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8799 12.6375L14.8789 12.6302L15.1864 12.453H15.1898L15.9009 12.8717L15.8981 12.879L14.8799 12.6375Z",
    fill: "#4C6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8971 12.8747L15.1857 12.4559L14.8789 12.6332L15.8971 12.8747Z",
    fill: "#4C6250"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7578 13.2793L14.4405 12.5283L14.444 12.5272L14.8824 12.6312L14.8834 12.6381L13.7626 13.2852L13.7578 13.2793Z",
    fill: "#298357"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8805 12.6333L14.4421 12.5293L13.7598 13.2804L14.8805 12.6333Z",
    fill: "#298357"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6085 17.6168L15.6074 17.6095L16.7278 16.9628L16.7327 16.9686L16.0503 17.7194L16.0469 17.7204L15.6085 17.6168Z",
    fill: "#298257"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.6094 17.6125L16.0475 17.7164L16.7298 16.9657L15.6094 17.6125Z",
    fill: "#298257"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8965 12.8773L15.8992 12.87L16.3187 12.9695L16.5958 13.2804L16.5909 13.2863L15.8965 12.8773Z",
    fill: "#446050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5929 13.2839L16.3175 12.9744L15.8984 12.8749L16.5929 13.2839Z",
    fill: "#446050"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8027 17.1881L13.584 16.9435L13.5892 16.9376L14.1347 17.2593L14.1319 17.2662L13.8027 17.1881Z",
    fill: "#535F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5898 16.9413L13.8061 17.1845L14.1357 17.2626L13.5898 16.9413Z",
    fill: "#535F4D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1311 17.266L13.5842 16.944L13.418 16.7571L12.832 14.5463L12.9626 14.1511L13.7559 13.278L14.8773 12.6299L15.8982 12.871L16.594 13.2804L17.6588 14.4772L17.7172 14.6952L17.096 16.5667L16.7315 16.9682L15.6104 17.6156L15.6073 17.6163L14.1311 17.266Z",
    fill: "#455E4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8996 12.8753L14.8814 12.6338L13.7607 13.2809L12.9685 14.1529L12.8379 14.5457L13.4225 16.7551L13.5883 16.9417L14.1342 17.263L15.6104 17.613L16.7308 16.9662L17.0946 16.5661L17.7155 14.6967L17.6581 14.4804L16.594 13.2843L15.8996 12.8753Z",
    fill: "#455E4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_164_33782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166.5,
    height: 30.2727,
    fill: "white",
    transform: "translate(0.986328 -0.0020752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsdEducation);
export default __webpack_public_path__ + "static/media/bsd-education.96a284edfea9043d951a719dd1e911c1.svg";
export { ForwardRef as ReactComponent };